<av-menu-item
  [attr.aria-label]="'Re-invite to call' | translate"
  icon="chat"
  (select)="shareLink()"
  data-tid="conference/reinvite-call"
>
  <span translate>Re-invite in call</span>
</av-menu-item>
